import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";

// Pages
import HeroSection from "./Components/HomePage/HeroSection";
import AboutPage from "./Components/AboutUs/AboutUs";
import OurProcess from "./Components/OurProcess/FullProcessPage";
import FullServicesPage from "./Components/Services/FullServicesPage";
import FullContactUsPage from "./Components/ContactUs/FullContactUsPage";
import ScrollToTopButton from "./Components/ScrollToTop/ScrollToTop";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import ServiceAreas from "./Components/AboutUs/ServiceAreas";
import FullPortfolioPage from "./Components/Portfolio/FullPortfolioPage";
import FullPage from "./Components/ADU&newcustomhome/FullPage";
import FullHomeRemodelPage from "./Components/FullHomeRemodel/FullHomeRemodelPage";
import FullHOAPage from "./Components/HOACommercial/FullHOAPage";
import FullTakeoverPage from "./Components/TakeoverProjects/FullTakeoverPage";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar />

        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/process" element={<OurProcess />} />
            <Route path="/services" element={<FullServicesPage />} />
            <Route path="/services/custom-homes" element={<FullPage />} />
            <Route path="/services/full-home-remodels" element={<FullHomeRemodelPage />} />
          <Route path="/services/hoa-commercial" element={<FullHOAPage />} />
           <Route path="/services/takeover-projects" element={<FullTakeoverPage />} />
            <Route path="/contact" element={<FullContactUsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsAndConditions />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/portfolio" element={<FullPortfolioPage />} />
          </Routes>
        </div>

        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;